import Heading from './Heading.vue'
export default Heading



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Heading/index.js